import { render, staticRenderFns } from "./Second.vue?vue&type=template&id=18eb12e6"
import script from "./Second.vue?vue&type=script&lang=js"
export * from "./Second.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports